import { connect } from "react-redux";
import SocialNotesApp from "../components/SocialNotesApp";
import { setUIVisibilityState, fetchNotes, sendAlert, deleteNote, endorseDisclaimer, selectTopic, fetchGroups, fetchSingleTopic, fetchSingleNote, selectNote } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    var currentSlide = state.nodes.find(function(n) {
        return n.id === state.currentSlide;
    });
    return {
        cbook: state.cbook,
        currentSlide: state.currentSlide,
        visible: state.uiVisibilityState.notes,
        currentOnly: (currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.allow_notes) === "exam",
        session: state.session,
        groups: state.groups.groups,
        noteGroup: state.groups.noteGroup,
        topics: state.topics.allTopics,
        searchedTopics: state.topics.searchResult,
        isLoadingGroups: state.loading.indexOf("fetch_groups") > -1,
        notes: state.notes.notes,
        socialConfig: state.socialConfig,
        connections: state.connections,
        currentSearch: state.topics.currentSearch,
        isDeletingNote: state.loading.indexOf("delete_note") > -1,
        deletingNoteError: state.errors.find(function(e) {
            return e.key === "delete_note";
        }),
        isAcceptingDisclaimer: state.loading.indexOf("endorse_disclaimer") > -1,
        acceptDisclaimerError: state.errors.find(function(e) {
            return e.key === "endorse_disclaimer";
        })
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        close: function() {
            dispatch(setUIVisibilityState({
                state: {
                    notes: false
                }
            }));
        },
        fetchNotes: function(group, nodes) {
            dispatch(fetchNotes({
                group: group,
                options: {
                    nodes: nodes
                }
            }));
        },
        sendAlert: function(message, messageType, timeout) {
            dispatch(sendAlert({
                message: message,
                messageType: messageType,
                timeout: timeout
            }));
        },
        deleteNote: function(note, nodeIds) {
            dispatch(deleteNote({
                note: note,
                nodeIds: nodeIds
            }));
        },
        acceptDisclaimer: function() {
            dispatch(endorseDisclaimer());
        },
        selectTopic: function(topic) {
            if (topic) {
                dispatch(fetchSingleTopic({
                    topic: topic
                }));
            }
            dispatch(selectTopic({
                topic: topic
            }));
        },
        selectNote: function(note) {
            if (note) {
                dispatch(fetchSingleNote({
                    note: note
                }));
            }
            dispatch(selectNote({
                note: note
            }));
        },
        fetchGroups: function() {
            dispatch(fetchGroups());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialNotesApp);
